<template>
  <div class="d-flex justify-content-center mt-5" v-if="isLoading">
    <h1>
      loading...
    </h1>
  </div>
  <div v-else class="backgroundFrame">
    <div class="header">
      <div class="header-icon">
        <b-button @click="goToPostsPage(); hideCursor()">
          <font-awesome-icon :icon="['fas', 'arrow-to-left']" />
        </b-button>
      </div>
    </div>
    <div :class="{ 'CursorOn': activateMouse, 'CursorOff': !activateMouse }" @mousemove="showCursor">
      <hooper :progress="false" :autoPlay="true" :wheelControl="false" :hoverPause="false" :playSpeed="13000">
        <slide id="pl-slide">
          <p-l-table :dashboardData="dashboardData" />
        </slide>
        <slide class="d-flex justify-content-between flex-column w-100 h-100" v-for="element in postsData"
          :key="element.id">
          <div class="post-entry ">
            <div>
              <div class="post-entry-title">
                <p :style="`font-size: ${element.fontSize.title}rem`">
                  {{ element.postTitle }}
                </p>
              </div>
              <div class="post-entry-content" :style="`font-size: ${element.fontSize.content}rem`"
                v-html="element.postContent.replace(/^\n+|\n+$/g, '').replace(/\n/g, '<br>')">
              </div>
            </div>
          </div>
        </slide>
        <slide v-if="employee && laborAllocation">
          <AttendanceSheetDiagram :employee="employee" :laborAllocation="laborAllocation" />
        </slide>
        <slide>
          <div class="Post-entry-date">
            <div>
              <p>
                {{ time }} Uhr
              </p>
              <p>
                {{ date }}
              </p>
            </div>
          </div>
        </slide>
      </hooper>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { Hooper, Slide } from "hooper";
import "hooper/dist/hooper.css";
import PLTable from "./PLTable.vue";
import AttendanceSheetDiagram from "./AttendanceSheetDiagram.vue";
import "moment-timezone/builds/moment-timezone-with-data-1970-2030";
import moment from "moment-timezone";

export default {
  components: {
    Hooper,
    Slide,
    PLTable,
    AttendanceSheetDiagram
  },
  data() {
    return {
      postsData: {},
      dashboardData: {},
      employee: {},
      laborAllocation: {},
      showtime: false,
      waitAsec: false,
      date: null,
      time: null,
      isLoading: true,
      activateMouse: false,
    };
  },
  methods: {
    goToPostsPage() {
      this.$router.replace({ name: "posts" });
    },

    mountObserver() {
      const targetNode = document.getElementById("pl-slide");
      const config = { attributes: true };

      const callback = () => {
        setTimeout(this.sliderToggle(), 5000)
        console.log("observer notice");
      };
      const observer = new MutationObserver(callback);
      observer.observe(targetNode, config);
    },
    isInViewport() {
      const element = document.getElementById("pl-slide");
      const rect = element.getBoundingClientRect();
      return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <=
        (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <=
        (window.innerWidth || document.documentElement.clientWidth)
      );
    },
    async sliderToggle() {
      let requirements = await this.isInViewport();
      if (!this.showtime && requirements && !this.waitAsec) {
        console.log("timer initiated");
        this.waitAsec = true;
        setTimeout(() => {
          this.showtime = true;
        }, 2000);
        setTimeout(() => {
          this.showtime = false;
        }, 40000);
        setTimeout(() => {
          this.waitAsec = false;
        }, 50000);
      } else {
        console.log("recirements for true not met", requirements);
        return false;
      }
    },
    async fetchAllData() {
      const url = process.env.NODE_ENV === "development" ? "http://127.0.0.1:5003/clgmbh-logistikmonitor/europe-west3/fetch" : "https://europe-west3-clgmbh-logistikmonitor.cloudfunctions.net/fetch";
      try {
        const response = await fetch(url, {
          method: "POST",
          headers: {
            Authorization: this.$route.params.key ? this.$route.params.key : ""
          },
        });
        if (!response.ok) {
          throw new Error(`Response status: ${response.status}`);
        }
        const result = await response.json();
        this.dashboardData = result.compactDashboardData;
        this.employee = result.employee;
        this.laborAllocation = result.laborAllocation;
        this.postsData = result.posts;
      } catch (error) {
        console.error(error.message);
      }

      this.isLoading = false;
    },
    showCursor() {
      this.activateMouse = true;
    },
    hideCursor() {
      this.activateMouse = false;
    }
  },
  computed: {
    ...mapGetters({
      user: "user",
    }),
  },
  async beforeMount() {
    this.fetchAllData();

  },
  mounted() {
    setInterval(() => {
      this.time = moment(new Date()).locale('de').format('LTS');
      this.date = moment(new Date()).locale('de').format('LL');
    }, 1000);

    setInterval(async () => {
      this.fetchAllData();
    }, 1000 * 60)
  },
};
</script>
<style>
.CursorOff {
  cursor: none !important;
}

.CursorOn {
  cursor: pointer !important;
}

.slider-item {
  max-width: 100% !important;
  max-height: 100% !important;
}

.hooper,
#pltable {
  color: white;
  height: 100vh !important;
}

.hooper {
  width: 100%;
}

#pltable {
  top: 60px;
  width: calc(100vw - 15px);
  background-color: #303030;
}

.centerContent {
  display: flex;
  align-items: center;
  justify-content: center;
}

table#tagesinformationen {
  font-size: 102pt;
}

img.wind,
img.temp {
  height: 66%;
  margin-right: 25px;
}

table#weather {
  font-size: 102pt;
}

table#tagesinformationen {
  font-size: 102pt;
}

.post-entry {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  height: 100vh;
  padding: 2rem 2rem 0 2rem;
}

.post-entry-title {
  text-align: center;
  width: 100%;
  background-color: #303030;
  border-radius: 16px;
  padding: 1rem;
}

.post-entry-title>p {
  font-weight: 700;
  overflow: hidden;
  hyphens: auto;
  word-break: break-word;
}

.post-entry-content {
  display: flex;
  justify-content: left;
  background-color: #303030;
  border-radius: 16px;
  margin-top: 2rem;
  padding: 2rem 4rem;
  width: 100%;
  font-weight: 600;
  overflow: hidden;
  hyphens: auto;
  word-break: break-word;
}

.Post-entry-date {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem 0;
  width: 100%;
  height: 100%;
}

.Post-entry-date>div {
  background-color: #303030;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.Post-entry-date>div>p {
  color: #eefa01;
  font-size: clamp(8rem, 11rem, 12rem);
  font-weight: 900;
  font-family: monospace !important;
}

.backgroundFrame {
  height: 100%;
  background: center bottom no-repeat;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  background-color: #252525;
}

.header {
  z-index: 1001;
  padding: 0;
  display: flex;
  position: fixed;
  background-color: transparent;
}

.header-icon>button {
  margin: 0.5rem;
  background-color: transparent;
  color: #353434;
  border: 0;
  cursor: pointer;
}
</style>